export const PARTNER_STATUS_APPEARANCE = {
  ACCEPTED: {color: 'green'},
  PENDING: {color: 'orange'},
  REJECTED: {color: 'red'},
};
